import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { adminLogin } from '../../services/authApi';
import { pingHealth } from '../../services/healthApi';
import { isPortalAdmin } from '../../utils/portalRoles';
import './AdminLogin.css';
import BrandLogo from '../../components/BrandLogo';
import AppVersion from '../../components/AppVersion';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login, token, user } = useAuth();

  useEffect(() => {
    pingHealth();
  }, []);

  useEffect(() => {
    const storedUserStr = localStorage.getItem('user');
    const storedUser = storedUserStr ? (() => { try { return JSON.parse(storedUserStr); } catch { return null; } })() : null;
    const finalUser = user || storedUser;
    const hasToken = token || localStorage.getItem('token');

    if (hasToken && finalUser && isPortalAdmin(finalUser.role)) {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [token, user, navigate]);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await adminLogin(formData.email, formData.password);

      let nextToken = response.data.token;
      if (nextToken && nextToken.startsWith('Bearer ')) {
        nextToken = nextToken.substring(7);
      }

      const userData = {
        ...response.data.user
      };

      login(nextToken, userData);
      window.location.href = '/admin/dashboard';
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        setError(
          err.response?.data?.message ||
            'Invalid email or password, or you do not have portal access.'
        );
      } else if (!err.response) {
        setError('Unable to reach the server. Please try again in a moment.');
      } else {
        setError(err.response?.data?.message || 'Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="card">
        <div className="admin-login-brandmark">
          <BrandLogo variant="default" />
        </div>
        <h1>Admin Login</h1>
        <p>Sign in as Super Admin, Brand Admin, or Branch Admin</p>

        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="admin-login-email">Email</label>
            <input
              id="admin-login-email"
              type="email"
              name="email"
              autoComplete="username"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="admin-login-password">Password</label>
            <input
              id="admin-login-password"
              type="password"
              name="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <AppVersion className="admin-login-version" />
      </div>
    </div>
  );
};

export default AdminLogin;
